import Api, {urls} from '../../services/api'
import {ApiResponseList, ApiResponseType, SortingType, TestimonialType} from './types'
import logException from '../../services/sentry'
import showNotification from '../../functions/notification'
import {testimonialActions} from '../slices'
import {AppDispatch} from '..'
import {apiErrorBlock} from '../../functions/utils'

export const getTestimonalList = (params: SortingType) => async (dispatch: AppDispatch) => {
  try {
    const {page} = params
    const response: ApiResponseList<TestimonialType[]> = await Api.get(
      `${urls.testmonials}?page=${page}${
        params.per_page && params.per_page > 0 ? `&per_page=${params.per_page}` : ''
      }`,
    )
    const {status, message, data} = response.data
    if (status && data?.data) {
      await dispatch(
        testimonialActions.updateTestimonialList({
          testimonialList: data.data,
          total: data.total || 0,
          from: data.from || 0,
        }),
      )
    }
    logException(new Error(message))
    if (message) showNotification({title: 'Error', message, type: 'danger'})
  } catch (e: any) {
    apiErrorBlock(e)
  }
}
export const addTestimonial = (params: FormData) => async (dispatch: AppDispatch) => {
  try {
    const response: ApiResponseList<TestimonialType[]> = await Api.post(
      `${urls.testmonials}`,
      params,
    )
    const {status, message} = response.data
    if (status && message) {
      if (message) showNotification({title: 'Success', message, type: 'success'})
      await dispatch(getTestimonalList({page: 1}))
      return true
    }
    logException(new Error(message))
    if (message) showNotification({title: 'Error', message, type: 'danger'})
    return false
  } catch (e: any) {
    apiErrorBlock(e)
    return false
  }
}
export const updateTestimonial =
  (id: number, params: FormData) => async (dispatch: AppDispatch) => {
    try {
      const response: ApiResponseList<TestimonialType[]> = await Api.post(
        `${urls.testmonials}/${id}`,
        params,
      )
      const {status, message} = response.data
      if (status && message) {
        if (message) showNotification({title: 'Success', message, type: 'success'})
        await dispatch(getTestimonalList({page: 1}))
        return true
      }
      logException(new Error(message))
      if (message) showNotification({title: 'Error', message, type: 'danger'})
      return false
    } catch (e: any) {
      apiErrorBlock(e)
      return false
    }
  }

export const getTestimonialDetail = (id: number) => async (dispatch: AppDispatch) => {
  try {
    const response: ApiResponseType<TestimonialType> = await Api.get(`${urls.testmonials}/${id}`)
    const {status, message, data} = response.data
    if (status && data) {
      await dispatch(testimonialActions.updateTestimonialDetail({testimonialDetail: data}))
      return true
    }
    logException(new Error(message))
    if (message) showNotification({title: 'Error', message, type: 'danger'})
    return false
  } catch (e: any) {
    apiErrorBlock(e)
    return false
  }
}
export const clearTestimonialDetail = () => async (dispatch: AppDispatch) => {
  try {
    await dispatch(testimonialActions.clearTestimonialDetail())
    return true
  } catch (e: any) {
    apiErrorBlock(e)
    return false
  }
}
export const deleteTestimonial =
  (id: number, options: SortingType) => async (dispatch: AppDispatch) => {
    try {
      const response: ApiResponseList<TestimonialType[]> = await Api.delete(
        `${urls.testmonials}/${id}`,
      )
      const {status, message} = response.data
      if (status && message) {
        if (message) showNotification({title: 'Success', message, type: 'success'})
        await dispatch(getTestimonalList(options))
        return true
      }
      logException(new Error(message))
      if (message) showNotification({title: 'Error', message, type: 'danger'})
      return false
    } catch (e: any) {
      apiErrorBlock(e)
      return false
    }
  }
